import { makeStyles, Typography } from "@material-ui/core";
import { FC } from "react";

const useStyles = makeStyles(() => ({
  errorText: {
    paddingTop: 5,

    "&:first-letter": {
      textTransform: "capitalize",
    },
  },
}));

const ErrorMessage: FC<ErrorMessageProps> = (props) => {
  const { text } = props;
  const classes = useStyles();
  return (
    <Typography variant="body2" color="error" className={classes.errorText}>
      {text}
    </Typography>
  );
};

interface ErrorMessageProps {
  text: string;
}

export default ErrorMessage;
